import { Component, ElementRef, HostListener, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Subscription, interval } from 'rxjs';
import { UserService } from '../../services/user/user.service';
import { SessionStorageService } from 'ngx-webstorage';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from '../../shared/sidebar/sidebar.component';
import { HttpService } from '../../services/http/http.service';
import { NavigationComponent } from "../../shared/header-navigation/navigation.component";
import { TimerService } from '../../services/timer/timer.service';
import { ErrorHandlingService } from '../../services/error-handling/error-handling.service';

@Component({
  selector: 'app-full',
  standalone: true,
  templateUrl: './full.component.html',
  styleUrl: './full.component.scss',
  imports: [CommonModule, SidebarComponent, RouterOutlet, NavigationComponent]
})
export class FullComponent implements OnInit, OnDestroy {
  color = 'blue';
  showSettings = false;
  showMinisidebar = false;
  showDarktheme = false;
  bln_editMode = false;
  private heartbeatSub!: Subscription;
  private editCheckIntervalId: any;
  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    public router: Router,
    private http: HttpService,
    private sessionStorage: SessionStorageService,
    private el: ElementRef,
    private renderer: Renderer2,
    public userservice?: UserService,
    private timerService?: TimerService,
    private errorHandling?: ErrorHandlingService
  ) {
    // Block certain actions globally (same as previous logic)
    const events = 'cut copy paste keypress';
    events.split(' ').forEach((e: any) =>
      this.renderer.listen(this.el.nativeElement, e, (event: any) => {
        if (e === 'cut') {
          event.preventDefault();
        } else if (e === 'keypress') {
          if (event.which === 32 && !event.target.value?.length) {
            event.preventDefault();
          }
        }
      })
    );
  }

  // Only popstate (back/forward) is needed. 'window:duplicate' is not a standard event.
  @HostListener('window:popstate', ['$event'])
  onPopState(event: any) {
    // If event.state is null, often indicates direct navigation outside SPA (or back to unloaded state)
    console.log('event.state', event.state);
    if (event.state == null) {
      this.userservice?.logOut(0);
    } else {
      this.userservice?.releaseOnBackButton();
    }
  }

  ngOnInit() {
    console.log('FullComponent Loaded ✅');
    this.handleDuplicateNavigation();

    // Heartbeat to reset login counter on server (less frequent than before)
    // run every 60 seconds instead of 10 seconds to reduce load
    // this.heartbeatSub = interval(60_000).subscribe(() => this.resetLoginCounter());

    // initialize EditMode flag and check it periodically (1s)
    this.sessionStorage?.store('EditMode', false);
    this.editCheckIntervalId = setInterval(() => {
      this.bln_editMode = this.sessionStorage?.retrieve('EditMode');
    }, 1000);

    // Start idle timer once (only for authenticated users). Use session flag to avoid double start.
    const userId = this.sessionStorage?.retrieve('userId');
    console.log(this.sessionStorage.retrieve('timerStarted'));
    if (userId) {
      // fetch timeout from server (if not stored already)
      this.http.getMethod('parameter/getAllParameters').subscribe({
        next: (res: any) => {
          if (res?.result?.tbl_config_TimeoutPeriod) {
            const timeOutPeriod = res.result.tbl_config_TimeoutPeriod;
            this.timerService?.startCheck(timeOutPeriod);
            console.log('timerStart..👀');
            this.sessionStorage?.store('timerStarted', true);
          } else {
            // fallback: you could set a default here or handle error
            console.warn('Timeout period not available from server');
          }
        },
        error: (err: any) => {
          console.error('Failed to fetch parameters for timeout', err);
          this.errorHandling?.checkError(err?.status || 500);
        }
      });
    }
  }

  private handleDuplicateNavigation() {
    try {
      const navEntries = window.performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
      const navigationType = navEntries && navEntries.length ? navEntries[0].type : null;
      console.log('navigationType', navigationType);
      if (navigationType === 'back_forward') {
        // If the browser restored a back/forward navigation entry, force reload and logout
        window.location.reload();
        this.userservice?.logOut(2);
      }
    } catch (err) {
      console.warn('navigation detection not supported', err);
    }
  }

  // resetLoginCounter() {
  //   const userID = this.sessionStorage?.retrieve('userId');
  //   if (userID != null) {
  //     const data: Object = { userId: userID };
  //     this.http.postMethodForIndex('loginCounter/resetLoginCounter', data).subscribe({
  //       next: () => { /* noop */ },
  //       error: (err) => { console.warn('resetLoginCounter failed', err); }
  //     });
  //   }
  // }

  ngOnDestroy() {
    // cleanup
    this.heartbeatSub?.unsubscribe();
    if (this.editCheckIntervalId) clearInterval(this.editCheckIntervalId);
  }
}
